<template lang="pug">
div.main-content
  div.title 首页大厅
  div.case-back
    img(src='../../assets/case/backrgound.png',
      style='margin-top: 0;margin-bottom: 0;').case-back
    div(v-for='(item,index) in hallList',
      :class='`hall${index}`'
        ).hallbackground
      span {{item.name === "" ? index+1: item.name}}
  div.title  编辑部门信息
  div.edit-department
    Row(:gutter="16")
      Col(span="8",v-for='(item,index) in hallList',
        :key='index',
        style='margin-top: 12px;')
        div(style='display: inline-block;width: 20px;') {{index+1}}.
        input(v-model='item.name',placeholder='编辑部门名称',:maxlength="10").role-name
        Icon(type="ios-close-circle",v-if='index>2',color='red',size='22',
          @click='delDept(index)').icon
    Button(icon="md-add",
      style='color:#3A76D2;border: 1px solid #3A76D2;margin-top: 22px;',
      @click='add_department') 添加
  component(v-for='(item,index) in assemblyList',
    :key='index',
    :is='item.name',
    :data='item.data'
    :assemblyName='assemblyName',
    :ref="'indexhome'+index"
    @upData="upData(index)",
      v-disabled="seeState"

    @downData="downData(index)"
    @data1:data ="val => item.data = val",
    @delModel='delModel(index)').model
  div.drag(@drop="fun_drop",@dragover="allowDrop")
    p  把题型或者案例内容拖入此区域吧!
</template>
<script>
import Single from "@/components/case/single";
import MultipleA from "@/components/case/multiple";
import MultipleB from "@/components/case/multiple";
import Fillblank from "@/components/case/fillblank";
import EasyQuestion from "@/components/case/easyQuestion";
import Material from "@/components/case/material";
import Matrix from "@/components/case/matrix";
import CaseAxis from "@/components/case/caseAxis";
import CaseTitle from "@/components/case/caseTitle";
import CaseInfoBase from "@/components/case/caseInfoBase";
import CaseDepartment from "@/components/case/caseDepartment";
import CaseUpload from "@/components/case/caseUpload";
import CaseAskAndAnswer from "@/components/case/caseAskAndAnswer";
import determineQuestion from "@/components/case/determineQuestion";
import TableQuestion from "@/components/case/tableQuestion";
import ligatureQuestion from "@/components/case/ligatureQuestion";
import CaseDialogue from "@/components/case/caseDialogue";
import CaseGuide from "@/components/case/caseGuide";
import CasePhotoText from "@/components/case/casePhotoText";
import CaseSingleText from "@/components/case/caseSingleText";
import CaseTitleText from "@/components/case/caseTitleText";
import CaseVideo from "@/components/case/caseVideo";
import MultipeChoice from "@/components/case/multipeChoice";
import Divider from "@/components/case/divider";

// 部门
import LEADERSHIPOFFICE from "@/components/department/LeadershipOffice";
import MYOFFICE from "@/components/department/myOffice";
import SURVEY from "@/components/department/survey";
import POLLINGCENTER from "@/components/department/researchCenter";
import Unit from "@/components/department/scene";
import smallCaseTitle from "../case/smallCaseTitle";

export default {
  components: {
    Single,
    MultipleA,
    MultipleB,
    Fillblank,
    EasyQuestion,
    Material,
    Matrix,
    CaseAxis,
    CaseDialogue,
    CaseGuide,
    CasePhotoText,
    CaseInfoBase,
    CaseDepartment,
    CaseUpload,
    CaseAskAndAnswer,
    determineQuestion,
    TableQuestion,
    ligatureQuestion,
    CaseSingleText,
    CaseTitleText,
    CaseVideo,
    CaseTitle,
    MultipeChoice,
    Divider,
    LEADERSHIPOFFICE,
    MYOFFICE,
    SURVEY,
    POLLINGCENTER,
    UnitA: Unit, // 5
    UnitB: Unit, // 6
    UnitC: Unit, // 7
    UnitD: Unit, // 8
    UnitE: Unit, // 9
    UnitF: Unit, // 10
    UnitG: Unit, // 11
    UnitH: Unit, // 12
    UnitI: Unit, // 13
    UnitJ: Unit, // 14
    UnitK: Unit, // 15
    UnitL: Unit, // 16
    UnitM: Unit, // 17
    UnitN: Unit, // 18
    UnitO: Unit, // 19
    UnitP: Unit, // 20
    UnitQ: Unit, // 21
    smallCaseTitle,
  },
  inject: ["seeState"],

  props: ["assemblyName"],
  data() {
    return {
      assemblyList: [], // 拖进来的组件
      stageShow: "", // 步骤信息
      // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      hallList: [
        { name: "首页大厅", state: true },
        { name: "我的办公室", state: true },
        { name: "领导办公室", state: true },
        { name: "民意调查中心", state: true },
      ], // 大厅的列表 12个大厅部门
    };
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
  },
  methods: {
    upData(index) {
      if (index === 0) {
        return this.$Message.error("已经是第一个控件啦!");
      }
      [this.assemblyList[index], this.assemblyList[index - 1]] = [
        this.assemblyList[index - 1],
        this.assemblyList[index],
      ];
      this.$forceUpdate();
    },
    downData(index) {
      if (index + 1 === this.assemblyList.length) {
        return this.$Message.error("已经是最后一个控件啦!");
      }
      [this.assemblyList[index], this.assemblyList[index + 1]] = [
        this.assemblyList[index + 1],
        this.assemblyList[index],
      ];
      this.$forceUpdate();
    },
    add_department() {
      console.log("this.hallList", this.hallList);
      // 添加部门
      // 多了办公室和现场调研
      if (this.hallList.length < 12) {
        this.hallList.push({ name: "部门", state: true });
      } else {
        this.$Message.error("最多添加10个部门");
      }
    },
    fun_drop() {
      if (
        this.assemblyName !== "" &&
        this.assemblyName !== "LEADERSHIPOFFICE" &&
        this.assemblyName !== "MYOFFICE" &&
        this.assemblyName !== "POLLINGCENTER" &&
        this.assemblyName !== "UnitA" &&
        this.assemblyName !== "UnitB" &&
        this.assemblyName !== "UnitC" &&
        this.assemblyName !== "UnitD" &&
        this.assemblyName !== "UnitE" &&
        this.assemblyName !== "UnitF"
      ) {
        //
        this.assemblyList.push({ name: this.assemblyName, data: {} });
      } else {
        this.$Message.warning("请到任务下添加场景");
      }
    },
    allowDrop(e) {
      e.preventDefault();
    },
    delModel(value) {
      // 删除模块
      console.log(value);
      console.log("assemblyList", this.assemblyList);
      if (this.assemblyList[value].data.id) {
        this.$emit("delModel", this.assemblyList[value].data.id);
      }
      this.$store.commit("deleteControl", this.assemblyList[value].data.id);
      this.assemblyList.splice(value, 1);
      this.$forceUpdate();
    },
    delDept(index) {
      this.$Modal.confirm({
        title: "系统提示",
        content: "<p>你确定要删除此数据吗?</p>",
        onOk: async () => {
          // this.handlesocredata();
          if (this.hallList[index].id) {
            // 删除部门
            await this.$http.batchDeletingCaseDepartmentStep({
              ids: JSON.stringify([this.hallList[index].id]),
            });
          }

          this.$Message.success("删除成功");
          this.hallList.splice(index, 1);
        },
      });
    },
  },
};
</script>
<style lang="stylus"></style>
